// The left pane of the verification view (TGCLOUD-1868, plan D1, D2, D5): a heading with the
// pane's own actions, the report drawn by ReportViewer, and, when the report cannot be drawn, the
// plan's sentence that nothing can be checked against it (D5). ReportViewer's own panel says what
// went wrong and offers "Try again", and "Open in a new tab" where it holds the file.
//
// Everything comes from the view (useVerificationView): the document, its boxes, the selection,
// the scroll request, and the two events. onRenderFailed is the last word on a document, and the
// view marks every value unverifiable from it.
import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import { useAutoTranslation } from 'src/hooks/useTranslate';
import ReportViewer from './ReportViewer';
import { REPORT_NOT_SHOWN } from './labReportVerificationVocabulary';

// `title` is translated by the caller.
export default function ReportPane({ view, title, actions = null }) {
  const t = useAutoTranslation();
  if (!view || !view.active) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto',
        minHeight: 0,
        minWidth: 0
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1,
          px: 1.5,
          py: 0.75,
          borderBottom: 1,
          borderColor: 'divider',
          flex: 'none'
        }}
      >
        <Typography
          component="h3"
          variant="subtitle2"
          sx={{ fontWeight: 700, flex: 1, minWidth: 0 }}
        >
          {title}
        </Typography>
        {actions}
      </Box>
      {view.reportStatus === 'failed' && (
        <Alert
          severity="warning"
          data-testid="report-not-shown"
          sx={{ borderRadius: 0, flex: 'none' }}
        >
          {t(REPORT_NOT_SHOWN)}
        </Alert>
      )}
      <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
        <ReportViewer
          document={view.document}
          anchors={view.anchors}
          selectedPaths={view.selectedPaths}
          onSelectAnchor={view.onSelectAnchor}
          scrollRequest={view.scrollRequest}
          onRendered={view.onRendered}
          onRenderFailed={view.onRenderFailed}
          readOnly={view.readOnly}
        />
      </Box>
    </Box>
  );
}
